import React from 'react';

function Hero() {
  return (
    <section style={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      background: 'linear-gradient(120deg, #0b1220 0%, #1e1b4b 44%, #0d9488 74%, #e11d48 100%)',
      position: 'relative',
      overflow: 'hidden',
      width: 'calc(100% + 32px)',
      marginLeft: '-16px',
      marginRight: '-16px',
      maxWidth: 'none'
    }}>
      {/* Subtle background pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 22% 84%, rgba(6, 182, 212, 0.18) 0%, transparent 50%), radial-gradient(circle at 86% 20%, rgba(244, 63, 94, 0.18) 0%, transparent 45%), linear-gradient(180deg, rgba(2,6,23,0.55), rgba(2,6,23,0.42))',
        zIndex: 0
      }}></div>
      
      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ 
          marginBottom: '30px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <img 
            src="/dabra_logo.png" 
            alt="Dabra Logo" 
            style={{ height: '100px', width: 'auto', filter: 'brightness(0) invert(1)' }}
          />
        </div>
        
        <h1 className="hero-title" style={{ 
          marginBottom: '20px',
          animation: 'slideInUp 1s ease-out 0.3s both'
        }}>
          Applied Intelligence & Automation for Data-Driven Futures
        </h1>

        <p className="hero-lead" style={{ 
          fontSize: '1.2rem',
          maxWidth: '900px',
          margin: '0 auto 20px',
          animation: 'slideInUp 1s ease-out 0.6s both',
          fontWeight: 400
        }}>
          Leveraging cutting-edge AI and robust automation, we transform complex data into actionable
          insights and efficient operations across industries, with a proven track record in compliant
          healthcare solutions.
        </p>

        <p className="hero-sublead" style={{ 
          fontSize: '1rem',
          maxWidth: '780px',
          margin: '0 auto 30px',
          animation: 'slideInUp 1s ease-out 0.8s both'
        }}>
          We combine applied research with production-grade engineering to unlock value from
          data - improving efficiency, reducing errors, and enabling future-proof decision making.
        </p>

        <div className="hero-actions" style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '20px' }}>
          <a href="#services" className="hero-cta hero-cta-primary">Explore Our Solutions</a>
          <a href="#contact" className="hero-cta hero-cta-outline">Partner with Us</a>
        </div>
        
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          gap: '50px',
          flexWrap: 'wrap',
          marginTop: '60px',
          animation: 'slideInUp 1s ease-out 1s both'
        }}>
          {[
            { label: 'AI Models', value: '15+' },
            { label: 'Data Sources', value: '8' },
            { label: 'Partners', value: '3' }
          ].map((stat, index) => (
            <div 
              key={stat.label}
              style={{
                textAlign: 'center',
                animation: `float 3s ease-in-out ${index * 0.5}s infinite`
              }}
            >
              <div style={{
                fontSize: '2.5rem',
                fontWeight: 'bold',
                color: '#ffffff',
                marginBottom: '5px'
              }} className="metric-value">
                {stat.value}
              </div>
              <div style={{
                fontSize: '0.9rem',
                color: '#cbd5e1',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }} className="metric-label">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;
